<template>
	<div class="xs-12 flex wrap p4">
		<div class="flex xs-middle xs-left xs-12">
			<div class="xs-9 ta3">
				<p class="fs3 fw4 c6 pr2">{{ formType === 'multiple' ? $t("rows_to_add") : $t("total_days") }}:</p>
			</div>
			<div class="xs-3 xs-right">
				<core-form-input
					type="integer"
					name="how_many"
					size="small"
					:min="0"
					:max="150"
					componentName="j-base-input-number"
					v-model="form.howMany"
				/>
			</div>
		</div>
		<div class="flex xs-12 mt2">
			<div class="xs-9 pr2">
				<!-- Billed Amount -->
				<core-form-input
					name="billed_amount"
					size="small"
					componentName="j-base-input-number"
					:placeholder="$t('billed_amount')"
					v-model="form.billedAmount"
				/>
			</div>
			<div class="xs-3">
				<!-- Billed Currency -->
				<core-form-input
					name="billed_currency"
					size="small"
					componentName="core-select-currency"
					v-model="form.billedCurrency"
				/>
			</div>
		</div>
		<div class="flex xs-12 mt2">
			<div class="xs-9 pr2">
				<!-- Approved Amount -->
				<core-form-input
					name="approved_amount"
					size="small"
					componentName="j-base-input-number"
					:placeholder="$t('approved_amount')"
					v-model="form.approvedAmount"
				/>
			</div>
			<div class="xs-3">
				<!-- Approved Currency -->
				<core-form-input
					name="approved_currency"
					size="small"
					componentName="core-select-currency"
					v-model="form.approvedCurrency"
				/>
			</div>
		</div>
		<div class="xs-12 flex xs-middle xs-right">
			<j-button
				size="small"
				@click="$emit('addMany', form)"
				class="mt4"
			>{{ formType === 'multiple' ? $t("add_items") : $t("apply") }}</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"

export default {
	components: { CoreFormInput, JButton, CrmIcon },
	props: {
		formType: String
	},
	data() {
		return {
			form: {
				howMany: 1,
				billedAmount: null,
				billedCurrency:
					this.$store.state.settings.preferredCurrency ||
					null,
				approvedAmount: null,
				approvedCurrency:
					this.$store.state.settings.preferredCurrency ||
					null
			}
		}
	}
}
</script>